<app-navbar [title]="pageTitle">
	<button class="btn btn-primary me-2" *ngIf="!lockEdit" (click)="submit()">Zapisz</button>
	<button class="btn btn-primary me-2" *ngIf="lockEdit" (click)="editToggle()">Edycja</button>
	<a routerLink="/company" class="btn btn-danger"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<div class="container my-4">
	<ul class="nav nav-tabs" id="myTab" role="tablist">
		<li class="nav-item">
			<a
				class="nav-link active"
				id="podstawowe-tab"
				data-bs-toggle="tab"
				href="#podstawowe"
				role="tab"
				aria-controls="podstawowe"
				aria-selected="false"
				>Podstawowe</a
			>
		</li>
	</ul>
	<form class="my-4" (submit)="submit()">
		<div class="tab-content col-sm-11" id="myTabContent">
			<div class="tab-pane fade active show" id="podstawowe" role="tabpanel" aria-labelledby="podstawowe-tab">
				<fieldset [disabled]="lockEdit">
					<div class="mb-3 row">
						<label class="col-sm-3 col-form-label required" for="name">Nazwa</label>
						<input
							class="form-control col-sm-9"
							name="name"
							[(ngModel)]="company.name"
							id="name"
							required
						/>
					</div>
				</fieldset>
			</div>
		</div>
	</form>
</div>
